<template>
  <div>
    <div>
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        :disabled="disabled"
        @submit.prevent.native="submit">
        <el-form-item prop="password" :label="$t('userSignInForm.passwordLabel')">
          <el-input
            v-model="form.password"
            type="password"
            data-test="password-input"
            :placeholder="$t('userSignInForm.passwordLabel')">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-loading="loading"
            data-test="submit-button"
            type="success" style="width: 100%;"
            @click="submit">
            {{ $t('userSignInForm.submitButtonText') }}
          </el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-link @click="handleForgotPassword" :disabled="disabled">
          {{ $t('userSignInForm.forgotPassword') }}
        </el-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      showForgotPassword: false,
      rules: {
        password: [
          {
            required: true,
            message: this.$t('userSignInForm.validPasswordRequiredMessage'),
            trigger: 'blur',
          },
        ],
      },
      form: {
        password: '',
      },
    };
  },
  methods: {
    handleForgotPassword() {
      this.$emit('forgotPassword');
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) { return; }
        this.$emit('onLogin', { password: this.form.password });
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
